<script lang="ts">
    import Input from "./Forms/Input.svelte";
    import TextArea from "./Forms/TextArea.svelte";
    import {superForm} from 'sveltekit-superforms/client';
    import {page} from "$app/stores";
    import Turnstile from "./Forms/Turnstile.svelte";
    import {ArrowPath} from 'svelte-heros';
    import Alert from "./Alert.svelte";
    import { t } from '$lib/translations';
    import {pushEvent} from "$stores/googleAnalytics";

    export let section: Section;
    export let index: number;

    let loading = false;
    let showSuccessMessage = false;
    let submits = 0

    const {form, errors, enhance} = superForm($page.data.contactFrom, {
        resetForm: true,
        onSubmit: () => {
            loading = true;
            showSuccessMessage = false;
        },
        onUpdated: ({form}) => {
            loading = false;
            if (form.valid) {
                showSuccessMessage = true;
                submits++;
                pushEvent({event: "form_submit_contact"})
                pushEvent({event: "form_submit"})
            }
        },
    });
</script>
<div class="bg-gray-200">
    <div class="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8 lg:py-40">
        <div class="space-y-10 divide-y divide-gray-900/10">
            <div class="grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3">
                <div class="lg:pr-8">
                    <span class="text-base font-semibold leading-7 text-primary-500">{section.superTitle}</span>
                    {#if index === 0}
                        <h1 class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{section.title}</h1>
                    {:else}
                        <h2 class="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">{section.title}</h2>
                    {/if}

                    <p class="mt-6 text-base leading-7 text-gray-600">
                        {section.description}
                    </p>
                </div>


                <form use:enhance
                      class="rounded-3xl p-8 ring-1 ring-gray-900/10 sm:p-10 relative bg-white shadow-xl md:col-span-2"
                      method="POST" action="?/concatForm">

                    {#if showSuccessMessage}
                        <div class="mt-6">
                            <Alert title={$t('strings.forms.successMessage.title')} message={$t('strings.forms.successMessage.description')} />
                        </div>
                    {:else}
                        <Input name="name" id="name" type="text" title={$t('strings.forms.fields.name.title')} bind:value={$form.name}
                               errorMessage={$errors.name} bind:loading/>
                        <Input name="email" id="email" type="email" title={$t('strings.forms.fields.email.title')} bind:value={$form.email}
                               errorMessage={$errors.email} bind:loading placeholder="email@domain.com"/>
                        <Input name="tel" id="tel" type="tel" title={$t('strings.forms.fields.tel.title')} bind:value={$form.tel}
                               errorMessage={$errors.tel} bind:loading placeholder="+43 000 000"/>
                        <Input name="subject" id="subject" type="text" title={$t('strings.forms.fields.subject.title')} bind:value={$form.subject}
                               errorMessage={$errors.subject} bind:loading/>
                        <TextArea name="message" id="message" title={$t('strings.forms.fields.message.title')} bind:value={$form.message}
                                  errorMessage={$errors.message} bind:loading/>

                        <p class="text-gray-600 text-sm font-medium mt-6">
                            {$t('strings.forms.consent')}
                        </p>

                        <div class="mt-6">
                            {#key submits}
                                <Turnstile/>
                            {/key}
                        </div>

                        {#if $errors._errors?.length > 0}
                            <p class="text-sm text-red-600 mt-6">{$errors._errors} </p>
                        {/if}

                        <div class="mt-6">
                            <button disabled={loading} type="submit"
                                    class="flex w-full justify-center items-center rounded-md bg-primary-500 hover:bg-primary-400 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-400 disabled:bg-gray-500">
                                {#if loading}
                                    <ArrowPath size="1rem" class="animate-spin mr-1.5"/>
                                    {$t('strings.forms.loading')}
                                {:else}
                                    {$t('strings.forms.send')}
                                {/if}
                            </button>
                        </div>
                    {/if}
                </form>

            </div>
        </div>
    </div>
</div>
